import * as React from 'react';
const SvgDocumentFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <g clipPath="url(#document-filled_svg__clip0)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5.004a1.5 1.5 0 00-1.5 1.5v13a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5v-8.55a3.5 3.5 0 00-1.025-2.475l-2.45-2.45A3.5 3.5 0 008.05.004H3.5zm3.5 2.5a.5.5 0 01.5-.5h.55a1.5 1.5 0 011.06.44l2.45 2.449a1.5 1.5 0 01.44 1.06v.55a.5.5 0 01-.5.5H8a1 1 0 01-1-1v-3.5z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="document-filled_svg__clip0">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default SvgDocumentFilled;
